import m1 from "./../assets/outsourced/main/01.jpg";
import m2 from "./../assets/outsourced/main/02.jpg";
import m3 from "./../assets/outsourced/main/03.jpg";
import m4 from "./../assets/outsourced/main/04.jpg";

import p1_1 from "./../assets/outsourced/project01/01.jpg";
import p1_2 from "./../assets/outsourced/project01/02.jpg";
import p1_3 from "./../assets/outsourced/project01/03.jpg";
import p1_4 from "./../assets/outsourced/project01/04.jpg";
import p1_5 from "./../assets/outsourced/project01/05.jpg";

import p2_1 from "./../assets/outsourced/project02/01.jpg";
import p2_2 from "./../assets/outsourced/project02/02.jpg";
import p2_3 from "./../assets/outsourced/project02/03.jpg";
import p2_4 from "./../assets/outsourced/project02/04.jpg";
import p2_5 from "./../assets/outsourced/project02/05.jpg";

import p3_1 from "./../assets/outsourced/project03/01.jpg";
import p3_2 from "./../assets/outsourced/project03/02.jpg";
import p3_3 from "./../assets/outsourced/project03/03.jpg";


const outsourced = {
  main: {
    title: 'Projetos Terceirizados',
    description: 'Projetos realizados para outros arquitetos e designers, com o objetivo de facilitar a rotina e colaborar na entrega de projetos com excelência e agilidade.',
    images: [{
      image: m1,
      projectUrl: '/outsourced/1'
    }, {
      image: m2,
      projectUrl: '/outsourced/1'
    }, {
      image: m3,
      projectUrl: '/outsourced/2'
    }, {
      image: m4,
      projectUrl: '/outsourced/3'
    }],
  },
  projects: [
    {
      id: 1,
      title: 'Projeto 01',
      images: [p1_1, p1_2, p1_3, p1_4, p1_5]
    },
    {
      id: 2,
      title: 'Projeto 02',
      images: [p2_1, p2_2, p2_3, p2_4, p2_5]
    },
    {
      id: 3,
      title: 'Projeto 03',
      images: [p3_1, p3_2, p3_3]
    },
  ]
}

export default outsourced;
  